import { render, staticRenderFns } from "./index.vue?vue&type=template&id=b8c9ee3e&"
import script from "./zPayForgotPasswordClientForm.js?vue&type=script&lang=js&"
export * from "./zPayForgotPasswordClientForm.js?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=b8c9ee3e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports